


<template>
	<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
		<g id="Tooltip_Info2">
			<path id="Mask" fill-rule="evenodd" clip-rule="evenodd" d="M2 12C2 6.48 6.47 2 11.99 2C17.52 2 22 6.48 22 12C22 17.52 17.52 22 11.99 22C6.47 22 2 17.52 2 12ZM4 12C4 16.42 7.58 20 12 20C16.42 20 20 16.42 20 12C20 7.58 16.42 4 12 4C7.58 4 4 7.58 4 12Z" :fill="fill_color" :fill-opacity="opacity"/>
			<path id="?" d="M10.7891 14.7969C10.7995 14.1771 10.8698 13.6875 11 13.3281C11.1302 12.9688 11.3958 12.5703 11.7969 12.1328L12.8203 11.0781C13.2578 10.5833 13.4766 10.0521 13.4766 9.48438C13.4766 8.9375 13.3333 8.51042 13.0469 8.20312C12.7604 7.89062 12.3438 7.73438 11.7969 7.73438C11.2656 7.73438 10.8385 7.875 10.5156 8.15625C10.1927 8.4375 10.0312 8.8151 10.0312 9.28906H8.58594C8.59635 8.44531 8.89583 7.76562 9.48438 7.25C10.0781 6.72917 10.849 6.46875 11.7969 6.46875C12.7812 6.46875 13.5469 6.73438 14.0938 7.26562C14.6458 7.79167 14.9219 8.51562 14.9219 9.4375C14.9219 10.349 14.5 11.2474 13.6562 12.1328L12.8047 12.9766C12.4245 13.3984 12.2344 14.0052 12.2344 14.7969H10.7891ZM10.7266 17.2734C10.7266 17.0391 10.7969 16.8438 10.9375 16.6875C11.0833 16.526 11.2969 16.4453 11.5781 16.4453C11.8594 16.4453 12.0729 16.526 12.2188 16.6875C12.3646 16.8438 12.4375 17.0391 12.4375 17.2734C12.4375 17.5078 12.3646 17.7031 12.2188 17.8594C12.0729 18.0104 11.8594 18.0859 11.5781 18.0859C11.2969 18.0859 11.0833 18.0104 10.9375 17.8594C10.7969 17.7031 10.7266 17.5078 10.7266 17.2734Z" :fill="fill_color" :fill-opacity="opacity"/>
		</g>
	</svg>
</template>

<script>

import base_icon from '@/components/icons/base_icon';

export default {
	extends: base_icon
}
</script>

